export interface IdentityManagerConfiguration {
  IdentityManagerType: number;
  Configuration: Configuration;
  tenantId: string;
  oidc: string;
}

export interface Configuration {
  auth: auth;
  system: system;
}

export interface auth {
  clientId: string;
  authority: string;
  authorizationParams: authParam;
  domain: string;
}

export interface system {
  allowNativeBroker: boolean;
}

export interface authParam {
  redirect_uri: string;
}

export enum IdentityManagerType {
  Fake = 0,
  Msal = 1, // AzureAD
  Auth0 = 2, // Okta (Auth0)
  ActiveDirectory = 3,  //LDAP
}
